import React from "react";
import { withStyles, WithStyles, Box, Modal, Backdrop, Fade, CardMedia } from "@material-ui/core";
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { ImagenMensajeStyles } from "../../styles";

interface ImagenMensajeProps extends WithStyles<typeof ImagenMensajeStyles> {
  children?: React.ReactNode;
  className?: string;
  handleClose: () => void;
  open: boolean;
  mensaje: string;
  mobile: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(0.7, 0.7, 0.7),
    },
  }),
);

const ImagenMensajeComponent = (props: ImagenMensajeProps) => {
   const classes = useStyles();


  const handleClose = () => {
    props.handleClose();
  };

  return (
    <Box>
      <div>
        <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={props.open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={props.open}>
          <div className={classes.paper}>
          {props.mobile === true ? 
          <CardMedia
                       component="img"
                       style={{ maxWidth:800, maxHeight:800, width:'70%', display:'block', margin:'auto', borderRadius:'5px', border: '2px #3A3B3D'}}
                       image={props.mensaje}
                       title="Live from space album cover"
           />

          : 
          <CardMedia
                       component="img"
                       style={{maxHeight:500, maxWidth:500, width:'50%', display:'block', margin:'auto', borderRadius:'5px', border: '2px #3A3B3D'}}
                       image={props.mensaje}
                       title="Live from space album cover"
           />
          }
          </div>
        </Fade>
      </Modal>
      </div>
    </Box>
  );
};
export const ImagenMensaje = withStyles(ImagenMensajeStyles)(
  ImagenMensajeComponent
);
